(() => {
  const root = document.querySelector('.pdp-header-price');
  if (!root) return;

  const compareEl = root.querySelector('.pdp-header-price__compare');
  const saleEl = root.querySelector('.pdp-header-price__sale');
  const saveEl = root.querySelector('.pdp-header-price__save');
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

  const defaultOption = (opt, fallback) => (typeof opt === 'undefined' ? fallback : opt);

  const formatWithDelimiters = (cents, precision, thousands, decimal) => {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(cents) || cents == null) return '0';
    const number = (Math.round(cents) / 100).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsPart = parts[1] ? decimal + parts[1] : '';
    return dollars + centsPart;
  };

  const formatMoney = (cents) => {
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = moneyFormat.match(placeholder);
    if (!match) return formatWithDelimiters(cents, 2);
    let value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return moneyFormat.replace(placeholder, value);
  };

  const parseDisplayedMoneyToCents = (text) => {
    if (!text) return 0;
    let cleaned = String(text).replace(/[^\d.,-]/g, '').trim();
    if (!cleaned) return 0;
    if (cleaned.includes(',') && cleaned.includes('.')) {
      cleaned =
        cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')
          ? cleaned.replace(/\./g, '').replace(',', '.')
          : cleaned.replace(/,/g, '');
    } else if (cleaned.includes(',')) {
      const parts = cleaned.split(',');
      cleaned = parts[parts.length - 1].length <= 2 ? cleaned.replace(',', '.') : cleaned.replace(/,/g, '');
    }
    const amount = parseFloat(cleaned);
    return Number.isNaN(amount) ? 0 : Math.round(amount * 100);
  };

  const normalizeCents = (value) => {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') return Math.round(value);
    const raw = String(value).trim();
    if (raw.includes('.') || raw.includes(',')) return parseDisplayedMoneyToCents(raw);
    const parsed = parseInt(raw, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const gidToId = (gid) => {
    if (!gid) return null;
    const parts = String(gid).split('/');
    return parts[parts.length - 1] || null;
  };

  const getProductCatalog = () => {
    const catalog = {};
    document.querySelectorAll('script.kaching-bundles-product').forEach((script) => {
      try {
        const product = JSON.parse(script.textContent);
        if (product && product.id != null) catalog[String(product.id)] = product;
      } catch (error) {}
    });
    return catalog;
  };

  const getDealSettingsList = () => {
    const deals = [];
    document.querySelectorAll('script.kaching-bundles-deal-block-settings').forEach((script) => {
      try {
        deals.push(JSON.parse(script.textContent));
      } catch (error) {}
    });
    return deals;
  };

  const paintedBars = () =>
    Array.from(document.querySelectorAll('.kaching-bundles__bar')).filter((bar) => !bar.closest('.pdp-free-gifts'));

  const getActiveDeal = () => {
    const deals = getDealSettingsList();
    if (!deals.length) return null;
    let best = deals[0];
    let bestScore = -1;
    deals.forEach((deal) => {
      let score = 0;
      paintedBars().forEach((barEl) => {
        const bar = (deal.dealBars || []).find((item) => item.id === barEl.getAttribute('data-deal-bar-id'));
        if (!bar) return;
        const gifts = (bar.freeGifts || []).filter((gift) => gift && typeof gift === 'object');
        const strips = barEl.querySelectorAll('.kaching-bundles__free-gift');
        score += 10 + gifts.length;
        if (strips.length && gifts.length === strips.length) score += 80;
        if (strips.length > 1 && gifts.length > 1) score += 40;
        gifts.forEach((gift) => {
          if (gift.productGID || gift.productId) score += 25;
        });
      });
      if (score > bestScore) {
        best = deal;
        bestScore = score;
      }
    });
    return best;
  };

  const getDealBars = () => getActiveDeal()?.dealBars || [];

  const getSelectedBar = () =>
    document.querySelector('.kaching-bundles__bar--selected') ||
    document.querySelector('.kaching-bundles__bar input:checked')?.closest('.kaching-bundles__bar');

  const getSelectedBarSettings = (selectedBar) => {
    if (!selectedBar) return null;
    const barId = selectedBar.getAttribute('data-deal-bar-id');
    if (barId) {
      const match = getDealBars().find((bar) => bar.id === barId);
      if (match) return match;
    }
    const title = (selectedBar.querySelector('.kaching-bundles__bar-title')?.textContent || '').trim();
    const quantity = Number((title.match(/(\d+)\s*pack/i) || [])[1]);
    return quantity ? { quantity, freeGifts: [] } : null;
  };

  const getGiftCentsFromSettings = (barSettings, catalog) => {
    if (!barSettings) return 0;
    return (barSettings.freeGifts || []).reduce((total, gift) => {
      if (!gift || gift.giftType === 'shipping') return total;
      const quantity = Number(gift.quantity) || 1;
      const product = catalog[gidToId(gift.productGID)];
      if (!product) return total;
      const variantIds = (gift.variantGIDs || []).map(gidToId);
      const variant =
        (product.variants || []).find((item) => variantIds.includes(String(item.id))) || product.variants?.[0];
      if (!variant) return total;
      const unit = normalizeCents(variant.compareAtPrice || variant.compare_at_price || variant.price);
      return total + unit * quantity;
    }, 0);
  };

  const getGiftCentsFromDom = (selectedBar) => {
    if (!selectedBar) return 0;
    return Array.from(selectedBar.querySelectorAll('.kaching-bundles__free-gift__full-price')).reduce(
      (total, node) => total + parseDisplayedMoneyToCents(node.textContent),
      0
    );
  };

  const getSaleCentsFromDom = (selectedBar) => {
    if (!selectedBar) return 0;
    const priceNode =
      selectedBar.querySelector('.kaching-bundles__bar-pricing .kaching-bundles__bar-price') ||
      selectedBar.querySelector('.kaching-bundles__bar-price');
    return parseDisplayedMoneyToCents(priceNode?.textContent);
  };

  const getCompareCentsFromDom = (selectedBar) => {
    if (!selectedBar) return 0;
    const compareNode =
      selectedBar.querySelector('.kaching-bundles__bar-pricing .kaching-bundles__bar-full-price') ||
      selectedBar.querySelector('.kaching-bundles__bar-full-price');
    return parseDisplayedMoneyToCents(compareNode?.textContent);
  };

  const packCompareByBar = new Map();

  const extrasForBar = (barId) => {
    const live = window.__pdpKachingGifts;
    if (!barId || !live?.gifts?.length) return 0;
    return live.gifts
      .filter((gift) => Number(gift.price) > 0 && Array.isArray(gift.barIds) && gift.barIds.includes(barId))
      .reduce((sum, gift) => sum + Number(gift.price), 0);
  };

  const packOriginalCents = (quantity) => {
    const unitPrice = Number(root.dataset.unitPrice) || 0;
    const unitCompare = Number(root.dataset.unitCompare) || unitPrice;
    return unitCompare * (Number(quantity) || 1);
  };

  const rememberPackValue = (map, barId, cents, sample) => {
    if (!barId) return { cents, sample };
    const current = map.get(barId);
    if (!current || current.cents <= 0) {
      if (cents > 0) map.set(barId, { cents, sample });
      return map.get(barId) || { cents, sample };
    }
    if (cents > 0 && cents < current.cents) {
      map.set(barId, { cents, sample });
    }
    return map.get(barId);
  };

  const formatWithTwoDecimals = (cents) => {
    const value = formatWithDelimiters(cents, 2);
    const placeholder = /\{\{\s*\w+\s*\}\}/;
    if (placeholder.test(moneyFormat)) return moneyFormat.replace(placeholder, value);
    return `$${value}`;
  };

  const getBarQuantity = (barEl, barSettings) => {
    if (Number(barSettings?.quantity)) return Number(barSettings.quantity);
    const title = (barEl?.querySelector('.kaching-bundles__bar-title')?.textContent || '').trim();
    return Number((title.match(/(\d+)\s*pack/i) || [])[1]) || 1;
  };

  const isPercentageSave = (barSettings, saveNode) => {
    const quantity = Number(barSettings?.quantity) || 0;
    const label = String(barSettings?.label || '');
    const shown = String(saveNode?.textContent || '');
    if (quantity === 1) return true;
    if (/saved_percentage/i.test(label) || /%/.test(label)) return true;
    if (/%/.test(shown)) return true;
    return false;
  };

  const setNodeMoney = (node, cents, extras = 0) => {
    if (!node) return;
    const nextCents = Math.max(0, (Number(cents) || 0) + (Number(extras) || 0));
    const nextText = formatWithTwoDecimals(nextCents);
    if (nextText && node.textContent.trim() !== nextText) node.textContent = nextText;
  };

  const updateBarPrices = () => {
    document.querySelectorAll('.kaching-bundles__bar').forEach((barEl) => {
      const barSettings = getSelectedBarSettings(barEl);
      const barId = barEl.getAttribute('data-deal-bar-id') || barSettings?.id || '';
      const quantity = getBarQuantity(barEl, barSettings);
      const extras = extrasForBar(barId);
      const packCompare = packOriginalCents(quantity);
      const compareNode =
        barEl.querySelector('.kaching-bundles__bar-pricing .kaching-bundles__bar-full-price') ||
        barEl.querySelector('.kaching-bundles__bar-full-price');
      if (compareNode) setNodeMoney(compareNode, packCompare, extras);
      const saleNode =
        barEl.querySelector('.kaching-bundles__bar-pricing .kaching-bundles__bar-price') ||
        barEl.querySelector('.kaching-bundles__bar-price');
      const saleCents = parseDisplayedMoneyToCents(saleNode?.textContent);
      if (saleNode && saleCents > 0) setNodeMoney(saleNode, saleCents);
      const saveCents = packCompare + extras - saleCents;
      const saveNode = Array.from(barEl.querySelectorAll('.kaching-bundles__bar-label, .kaching-bundles__bar-badge')).find(
        (node) => /save/i.test(node.textContent || '')
      );
      if (saveNode && isPercentageSave(barSettings, saveNode)) return;
      if (saveNode) {
        if (saveCents > 0) {
          const nextText = `SAVE ${formatWithTwoDecimals(saveCents)}`;
          if (saveNode.textContent.trim() !== nextText) saveNode.textContent = nextText;
          saveNode.hidden = false;
        } else {
          saveNode.hidden = true;
        }
      }
    });
  };

  let updating = false;

  const updatePrice = () => {
    if (updating) return;
    updating = true;

    try {
      updateBarPrices();

      const unitPrice = Number(root.dataset.unitPrice) || 0;
      const unitCompare = Number(root.dataset.unitCompare) || unitPrice;
      const selectedBar = getSelectedBar();
      const barSettings = getSelectedBarSettings(selectedBar);
      const quantity = getBarQuantity(selectedBar, barSettings);
      const barId = selectedBar?.getAttribute('data-deal-bar-id') || barSettings?.id || '';
      const extras = extrasForBar(barId);
      const saleCents = getSaleCentsFromDom(selectedBar) || unitPrice * quantity;
      const packCompare = packOriginalCents(quantity);
      const compareCents = packCompare + extras;
      const savingsCents = compareCents - saleCents;

      saleEl.textContent = formatWithTwoDecimals(saleCents);

      if (compareCents > saleCents) {
        compareEl.textContent = formatWithTwoDecimals(compareCents);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }

      if (saveEl) {
        if (savingsCents > 0) {
          saveEl.textContent = `SAVE ${formatWithTwoDecimals(savingsCents)}`;
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }

      root.removeAttribute('data-pending');
      placeUnderTitle();
    } finally {
      updating = false;
    }
  };

  const placeUnderTitle = () => {
    const details = document.querySelector('.product-details');
    if (!details) return;
    const heading = details.querySelector('h1');
    if (heading && heading.nextElementSibling !== root) {
      heading.insertAdjacentElement('afterend', root);
    }
  };

  const observeKaching = () => {
    const kaching = document.querySelector('kaching-bundles-block, .kaching-bundles:not(.pdp-free-gifts)');
    if (!kaching || kaching.dataset.priceObserved === 'true') return;
    kaching.dataset.priceObserved = 'true';
    new MutationObserver(updatePrice).observe(kaching, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-checked'],
    });
    kaching.addEventListener('click', () => {
      window.requestAnimationFrame(updatePrice);
      window.setTimeout(updatePrice, 50);
    });
    kaching.addEventListener('change', updatePrice);
    updatePrice();
  };

  const start = () => {
    placeUnderTitle();
    if (document.querySelector('script.kaching-bundles-deal-block-settings')) {
      root.setAttribute('data-pending', 'true');
    }
    updatePrice();
    observeKaching();

    const bodyObserver = new MutationObserver(() => {
      observeKaching();
      if (document.querySelector('kaching-bundles-block, .kaching-bundles:not(.pdp-free-gifts)')?.dataset.priceObserved === 'true') {
        bodyObserver.disconnect();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('kaching-bundles-initialized', () => {
      observeKaching();
      updatePrice();
    });
    document.addEventListener('variant:update', (event) => {
      packCompareByBar.clear();
      const next = event.detail?.data?.html?.querySelector?.('.pdp-header-price');
      if (next?.dataset?.unitPrice) {
        root.dataset.unitPrice = next.dataset.unitPrice;
        root.dataset.unitCompare = next.dataset.unitCompare;
      }
      updatePrice();
    });
    window.addEventListener('pdp-kaching-gifts:change', updatePrice);
    window.setTimeout(() => root.removeAttribute('data-pending'), 2500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
